var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 550,
    viewBox: "0 0 309 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6887 80.1138L32.612 59.6994C15.7238 81.367 4.47644 107.624 1.08241 136.262L34.0154 139.892C36.7163 117.541 45.5121 97.0483 58.6887 80.1138Z",
    fill: "#D7DBED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1379 155.054L0 155.074C0.0239016 161.641 0.508763 168.099 1.33166 174.451L34.1486 169.888C33.5305 165.022 33.1652 160.081 33.1413 155.054H33.1379Z",
    fill: "#D7DBED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9791 184.815L4.85536 192.966C6.49091 199.322 8.52255 205.516 10.9195 211.53L41.6092 199.035C39.7858 194.425 38.2357 189.681 36.9791 184.818V184.815Z",
    fill: "#D7DBED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.446 33.9545L136.741 1.02449C101.1 5.12238 69.1029 21.3671 45.0408 45.5447L68.7137 68.708C87.5686 49.8509 112.59 37.1816 140.446 33.9545Z",
    fill: "#D7DBED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.559 0L155.613 33.1451C222.019 33.753 275.862 87.9442 275.862 154.501C275.862 221.057 221.414 275.884 154.493 275.884C108.677 275.884 68.7206 250.357 48.073 212.776L18.9507 228.574C45.2185 276.475 96.1187 309.025 154.493 309.025C239.689 309.025 309 239.706 309 154.501C309 69.2954 240.262 0.57712 155.559 0Z",
    fill: "#D7DBED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCircle);
export default __webpack_public_path__ + "static/media/background-circle.fb2b8787f48f4489a9a09cd937ea165f.svg";
export { ForwardRef as ReactComponent };